
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/public-affairs-staff",
      function () {
        return require("private-next-pages/media/public-affairs-staff/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/public-affairs-staff"])
      });
    }
  